<template>
    <div class="seller-page">
        <div class="page-route-select">
            <router-link to="/cliente/monitores/cotacoes" class="page-route-select-text">
                Home
            </router-link>
            <span class="material-icons page-route-select-icon">play_arrow</span>
            <router-link to="/fornecedores" class="page-route-select-text">
                Fornecedores
            </router-link>
            <span class="material-icons page-route-select-icon">play_arrow</span>
            <div class="page-route-select-text">Vendedores</div>
        </div>

        <div class="page-title">Vendedores</div>

        <div class="seller-inputs-container2">
            <div class="reactivate-container" @click="statusFilter = !statusFilter">
                <span class="material-icons-outlined reactivate-icon" v-if="!statusFilter">check_box_outline_blank</span>
                <span class="material-icons-outlined reactivate-icon" v-else>check_box</span>
                Visualizar excluídos
            </div>
            <StandardButton class="seller-input-size-1" text="filtrar" :action="filter" iconName="search" />
            <StandardButton
                class="seller-input-size-1"
                text="Limpar filtros"
                :action="
                    () => {
                        filters = {};
                        filter();
                    }
                "
                iconName="delete"
            />
            <StandardButton class="seller-input-size-1" text="Voltar" :action="goBack" iconName="arrow_back_ios" />
            <StandardButton class="seller-input-size-1" :action="() => showBlockedNumbers()" text="Bloqueados" iconName="notifications" />
        </div>

        <div class="seller-inputs-container">
            <StandardInput class="seller-input-size" :auto="true" :action="setName" title="Buscar por nome" type="text" />
            <StandardInput
                class="seller-input-size"
                :auto="true"
                :action="setState"
                title="Selecione um estado"
                :list="states"
                type="select"
            />
            <StandardInputListFilteredAuto
                class="seller-input-size"
                :value="filters.client"
                :auto="true"
                :action="setClient"
                title="Cliente"
                :list="clients"
                type="select"
            />
            <StandardInputListFilteredAuto
                class="seller-input-size"
                :value="filters.provider"
                :auto="true"
                :action="setProvider"
                title="Fornecedor"
                :list="providers"
                type="select"
            />
        </div>

        <div class="page-table-header">
            <div class="page-table-header-text id-width">Nome / ID</div>
            <div class="page-table-header-text email-width">Email / Login</div>
            <div class="page-table-header-text password-width">Senha</div>
            <div class="page-table-header-text phone-width">Fornecedor / Telefone</div>
            <div class="page-table-header-text state-width">Estado / Cidade</div>
            <div class="page-table-header-text state-width part-header" @click="() => setOrder('sum_pedidos')">
                Val. Pedidos
                <span v-if="orderCollum == 'sum_pedidos' && orderDesc" class="material-icons-outlined">expand_more</span>
                <span v-else-if="orderCollum == 'sum_pedidos'" class="material-icons-outlined">expand_less</span>
                <span v-else class="material-icons-outlined">unfold_more</span>
            </div>
            <div class="page-table-header-text state-width part-header" @click="() => setOrder('count_vendedor')">
                Clientes
                <span v-if="orderCollum == 'count_vendedor' && orderDesc" class="material-icons-outlined">expand_more</span>
                <span v-else-if="orderCollum == 'count_vendedor'" class="material-icons-outlined">expand_less</span>
                <span v-else class="material-icons-outlined">unfold_more</span>
            </div>
            <div class="page-table-header-text part-width part-header" @click="() => setOrder('participation')">
                Participação
                <span v-if="orderCollum == 'participation' && orderDesc" class="material-icons-outlined">expand_more</span>
                <span v-else-if="orderCollum == 'participation'" class="material-icons-outlined">expand_less</span>
                <span v-else class="material-icons-outlined">unfold_more</span>
            </div>
            <div class="page-table-header-text actions-width">Ações</div>
        </div>

        <div class="seller-row" v-for="(seller, idx) in sellers" v-bind:key="seller.id" :class="getSpecialBackground(idx)">
            <div class="seller-row-text id-width">
                <div class="page-table-header-mobile">ID</div>
                {{ seller.name }} <br />
                {{ "# " + seller.id }}
            </div>
            <div class="seller-row-text email-width">
                <div class="page-table-header-mobile">Email</div>
                {{ seller.email }} <br />
                {{ seller.login }}
            </div>
            <div class="seller-row-text password-width">
                <div class="page-table-header-mobile">Senha</div>
                <span @click="showPasswordModal(seller)" class="material-icons-outlined password-icon" title="Ver Senha">
                    lock
                </span>
            </div>
            <div class="seller-row-text phone-width">
                {{ "# " + seller.provider.name }} <br />
                <cc-whatsapp v-if="seller.phone" :phone="seller.phone" />
                <span v-else>--</span>
            </div>
            <div class="seller-row-text state-width">
                <div class="page-table-header-mobile">Estado</div>
                {{ seller.provider.head_office && seller.provider.head_office.state ? seller.provider.head_office.state.name : "-" }}
                <br />
                {{ seller.provider.head_office && seller.provider.head_office.city ? seller.provider.head_office.city.name : "-" }}
            </div>
            <div class="seller-row-text state-width">
                {{ seller.sum_pedidos | currency }}
            </div>
            <div class="seller-row-text state-width">
                {{ seller.count_vendedor }}
            </div>
            <div class="seller-row-text part-width" :class="getPercent(seller.participation)">
                {{ (seller.participation * 100).toFixed(2) + " %" }}
            </div>
            <div class="seller-row-text actions-width">
                <div class="page-table-header-mobile">Ações</div>
                <div v-if="!statusFilter">
                    <span
                        class="material-icons-outlined seller-row-icon"
                        style="color: #20ce88"
                        title="Clientes"
                        @click="show_users(seller, true)"
                        >people</span
                    >
                    <span
                        class="material-icons-outlined seller-row-icon"
                        style="color: red"
                        title="Remover vendedor"
                        @click="remove_seller(seller)"
                        >delete</span
                    >
                    <span
                        class="material-icons-outlined seller-row-icon"
                        style="color: #5e72e4"
                        title="Editar vendedor"
                        @click="show_users(seller)"
                        >edit</span
                    >
                </div>
                <div v-else>
                    <span
                        class="material-icons-outlined seller-row-icon"
                        style="color: #46ad5d"
                        title="Reativar Vendedor"
                        @click="reactivate(seller)"
                    >
                        recycling
                    </span>
                </div>
            </div>
        </div>

        <div class="box-footer clearfix not-print">
            <cc-paginacao
                :key="'pag'"
                classes="orange"
                :items_by_page_value="items_by_page_value"
                :total="total_items"
                :page="paginaAtual"
                :page_limit="11"
                v-on:change="load($event)"
            ></cc-paginacao>
        </div>

        <cc-loader-full v-if="is_loading" />
        <SellerParticipationModal
            :seller="current_seller"
            @close="is_seller_participation_modal_open = false"
            v-if="is_seller_participation_modal_open"
        />
        <SellersModal
            @close="is_provider_users_modal_open = false"
            v-if="is_provider_users_modal_open"
            :seller_id="current_seller.id"
            :sellerName="current_seller.name"
            :to_clients="current_seller.to_clients"
            @reload="load"
            :provider="current_provider"
        />
        <SellersEditModal
            @close="showEditUserModal = false"
            v-if="showEditUserModal"
            :seller_id="current_seller.id"
            :sellerName="current_seller.name"
            :to_clients="current_seller.to_clients"
            @reload="load"
            :provider="current_provider"
        />
        <SellersLoginModal v-if="isPasswordModalOpen" @close="isPasswordModalOpen = false" :sellerInfo="sellerInfo" />
        <BlockedNumbersModal v-if="showBlockedNumbersModal" @close="showBlockedNumbersModal = false" />
    </div>
</template>
<script>
import Paginacao from "@/components/cliente/base-components/Pagination";
import SellerService from "@/services/v3/providers/seller.service";
import FilterService from "@/services/v3/filters/filter.service";
import SellersModal from "@/modals/providers/sellers/sellersClientsModal";
import SellersEditModal from "@/modals/providers/sellers/sellers.modal";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { loaderMixin } from "@/mixins/sweet-loader.mixin";
import SellerParticipationModal from "@/modals/providers/sellers/sellers-participation.modal";
import UserService from "@/services/v1/user.service";
import StandardButton from "@/components/ui/buttons/StandardButton.vue";
import StandardInput from "@/components/ui/inputs/StandardInputV2.vue";
import ClientServiceV2 from "@/services/v2/client.service";
import StandardInputListFilteredAuto from "@/components/ui/inputs/StandardInputListFilteredAuto.vue";
import SellersLoginModal from "@/modals/providers/sellers/sellers-password-modal.vue";
import BlockedNumbersModal from "@/modals/providers/sellers/blocked-numbers-modal.vue";

export default {
    mixins: [loaderMixin],
    components: {
        SellerParticipationModal,
        SellersModal,
        ccPaginacao: Paginacao,
        StandardButton,
        StandardInput,
        StandardInputListFilteredAuto,
        SellersLoginModal,
        SellersEditModal,
        BlockedNumbersModal,
    },
    data() {
        return {
            image: "/images/search.png",
            is_loading: false,
            orderCollum: "participation",
            paginaAtual: 1,
            total_items: 1,
            items_by_page_value: 120,
            svc: new SellerService(),
            user_svc: new UserService(),
            v2_cli_svc: new ClientServiceV2(),
            filter_svc: new FilterService(),
            sellers: [],
            states: [],
            providers: [],
            clients: [],
            isPasswordModalOpen: false,
            sellerInfo: undefined,
            is_provider_modal_open: false,
            is_provider_users_modal_open: false,
            is_seller_participation_modal_open: false,
            showEditUserModal: false,
            orderDesc: true,
            filters: {
                page: 1,
            },
            current_provider: null,
            breadcrumbs: [
                {
                    name: "Fornecedores",
                    route: "sellers",
                },
                {
                    name: "Vendedores",
                    route: "providers-sellers",
                },
            ],
            showBlockedNumbersModal: false,
            current_seller: null,
            statusFilter: false,
        };
    },
    watch: {
        statusFilter() {
            this.load();
        }
    },
    methods: {
        getSpecialBackground(idx) {
            if (idx % 2 != 0) return "page-table-line-special";
        },
        setName(value) {
            this.filters.name = value;
            if (value.length > 3 || value.length == 0) {
                this.load(this.page);
            }
        },
        setProvider(value) {
            this.filters.provider = value.id;
            this.load(1);
        },
        setState(value) {
            this.filters.state = value;
        },
        setClient(value) {
            this.filters.client = value;
            this.load();
        },
        goBack() {
            this.$router.push("/fornecedores");
        },
        filter() {
            this.paginaAtual = 1;
            this.load();
        },
        getPercent(value) {
            if (value <= 0.3) return "table-not-typed";
            else if (value >= 0.7) return "table-typed";
            else return "percent-orange";
        },
        show_participations(seller) {
            this.current_seller = seller;
            this.is_seller_participation_modal_open = true;
        },
        close_modal(reload = false) {
            this.is_provider_modal_open = false;
            this.current_provider = null;
            if (reload) {
                this.load();
            }
        },
        load_client_stores() {
            this.v2_cli_svc
                .list_client_stores()
                .then((response) => response.data)
                .then((data) => {
                    this.clients = data.data.map((cli) => {
                        return { value: cli.cli_id, text: cli.cli_nome_grupo };
                    });
                });
            this.svc.allSupliers().then((resp) => {
                this.providers = resp.data.data.map((v) => {
                    return { text: v.name, value: v };
                });
            });
        },
        show_users(seller, to_list_clients = false) {
            this.current_provider = seller.provider;
            this.current_seller = { ...seller, to_clients: to_list_clients };
            if (to_list_clients) this.is_provider_users_modal_open = true;
            else this.showEditUserModal = true;
        },
        load_region_data() {
            return this.user_svc
                .region_data()
                .then((response) => response.data)
                .then((data) => {
                    this.states = data.estados.map((state) => {
                        return { value: state, text: state.est_nome };
                    });
                });
        },
        remove_seller(seller) {
            this.confirm_action({
                message: `Confirma remoção do vendedor ${seller.name}?`,
                callback: () => this.remove(seller.id),
            });
        },
        remove(seller_id) {
            return this.svc.remove(seller_id).then(() => this.load());
        },
        showPasswordModal(seller) {
            this.sellerInfo = seller;
            this.isPasswordModalOpen = true;
        },
        setOrder(collum) {
            if (this.orderCollum != collum) {
                this.orderCollum = collum;
                this.orderDesc = true;
            } else this.orderDesc = !this.orderDesc;
            this.load(1);
        },
        load(new_page = this.paginaAtual) {
            this.paginaAtual = new_page;
            this.is_loading = true;
            let params = {
                name: this.filters.name,
                state_id: this.filters.state ? this.filters.state.est_id : null,
                provider_id: this.filters.provider,
                client_id: this.filters.client ? this.filters.client : null,
                page: this.paginaAtual,
                page_size: this.items_by_page_value,
                order_by: this.orderDesc ? "desc" : "asc",
                column: this.orderCollum,
                ...(this.statusFilter ? { excluded: this.statusFilter } : ""),
            };
            this.svc
                .load(params)
                .then((response) => response.data)
                .then((response) => {
                    this.sellers = response.data;
                    this.total_items = response.meta.total;
                    this.is_loading = false;
                })
                .catch((error) => {
                    this.is_loading = false;
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        showBlockedNumbers() {
            this.showBlockedNumbersModal = true;
        },
        reactivate(seller) {
            this.confirm_action({
                message: `Confirma reativação do vendedor ${seller.name}?`,
                callback: () => {
                    this.svc.reactivate(seller.id).then(this.load());
                },
            });
        },
    },
    created() {
        this.load();
        this.load_region_data();
        this.load_client_stores();
        this.$store.dispatch("set_breadcrumbs", this.breadcrumbs);
    },
};
</script>
<style lang="scss" scoped>
@import "@/sass/commons/_tables";

.seller-icon {
    color: $blue1;
    padding: 0 0.6rem;
    font-size: 1rem;
    &:hover {
        cursor: pointer;
    }
}

.id strong {
    font-weight: bolder;
    color: $primary-color;
}

td {
    height: 4rem !important;
}

.actions {
    justify-content: center;
    i {
        font-size: 1.2rem;
        cursor: pointer;
        &.fa-trash {
            color: red;
        }
    }
}
.seller-page {
    font-size: 1vw;
    padding-right: 5vw;
    padding-bottom: 5vh;
}
.seller-inputs-container {
    display: flex;
    align-items: flex-end;
    margin-top: 5vh;
    justify-content: space-between;
}
.seller-inputs-container2 {
    display: flex;
    align-items: flex-end;
    margin-top: 5vh;
    gap: 5vw;
    justify-content: flex-end;
}

.password-icon {
    cursor: pointer;
    color: var(--primary-color);
    margin-left: 10px;
}
.page-route-select {
    display: flex;
    align-items: center;
}
.page-route-select-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 17px;
    color: #ababab;
    margin-right: 20px;
    cursor: pointer;
}
.page-table-header {
    background: #fffefc;
    border: 0.5px solid #e5e5e5;
    font-weight: 400;
    color: #605f5f;
    display: flex;
    padding: 1em 0em;
    margin-top: 3vh;
    padding-left: 1vw;
}
.page-route-select-icon {
    color: var(--primary-color);
    margin-right: 20px;
}
.page-title {
    font-weight: 700;
    font-size: 2.5em;
    line-height: 24px;
    letter-spacing: 0.15px;
    color: #605f5f;
    margin-top: 40px;
}
.seller-input-size {
    width: 22%;
}
.id-width {
    flex: 1;
}
.email-width {
    width: 25%;
}
.login-width {
    width: 10%;
}
.password-width {
    width: 5%;
}
.phone-width {
    width: 17%;
}
.provider-width {
    width: 10%;
}
.state-width {
    width: 9%;
}
.city-width {
    width: 9%;
}
.actions-width {
    width: 9%;
}
.part-width {
    width: 9%;
}

.seller-row {
    display: flex;
    align-items: center;
    padding: 3vh 0;
}
.seller-row-text {
    color: #4d4f5c;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 10px;
    white-space: nowrap;
}
.seller-row-icon {
    font-size: 2em;
    cursor: pointer;
}
.page-table-line-special {
    background: #f7f7f7;
}
.page-table-header-mobile {
    display: none;
}
.table-not-typed {
    background-color: lightcoral;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
}
.part-header {
    cursor: pointer;
    display: flex;
    align-items: center;
}
.percent-orange {
    background-color: lightsalmon;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
}
.table-typed {
    background-color: lightgreen;
    font-weight: bold;
    text-transform: uppercase;
    color: white;
    border-radius: 10px;
    padding: 0 1vw;
    text-align: center;
}
.reactivate-container {
    display: flex;
    gap: 1vw;
    cursor: pointer;
    align-items: center;
    font-weight: 600;
    font-size: 1.1em;
    color: #202020;
}
.reactivate-icon {
    font-size: 2em;
    color: var(--primary-color);
}

@media only screen and (max-width: 1000px) {
    .seller-page {
        font-size: 1.5vw;
    }
}
@media only screen and (max-width: 900px) {
    .seller-row {
        flex-direction: column;
        font-size: 2em;
    }
    .seller-input-size {
        width: 100%;
    }
    .id-width {
        width: 100%;
    }
    .name-width {
        flex: unset;
        width: 100%;
    }
    .email-width {
        width: 100%;
    }
    .login-width {
        width: 100%;
    }
    .password-width {
        width: 100%;
    }
    .phone-width {
        width: 100%;
    }
    .provider-width {
        width: 100%;
    }
    .state-width {
        width: 100%;
    }
    .city-width {
        width: 100%;
    }
    .actions-width {
        width: 100%;
    }
    .seller-row-text {
        display: flex;
        justify-content: space-between;
    }
    .page-table-header-mobile {
        font-size: 1.2em;
        font-weight: bold;
        display: flex;
    }
    .seller-inputs-container {
        flex-direction: column;
        gap: 2vh;
    }
    .seller-input-size-1 {
        width: 30%;
    }
    .page-table-header {
        display: none;
    }
}
@media only screen and (max-width: 600px) {
    .seller-page {
        font-size: 2.5vw;
    }
}
</style>
